import React, {useEffect, useRef,useState } from "react"; 
import { Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../quizAssets.css'; 
import Form from 'react-bootstrap/Form';
import { toast } from 'react-toastify';
import { createQuizAsset } from "../../../Services/Assets/assetsService";
const CreateAsset = ({ isShow,close }) => {   
  const handleClose = () => {setShow(false);close()};
  const [show, setShow] = useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [assetName, setAssetName] = useState("");
  const [preview, setPreview] = useState(null);
  const [assetFile, setAssetFile] = useState("");
  const [assetNameError, setAssetNameError] = useState(false);
  const [assetError, setAssetError] = useState(false);
  const assetnameRef = useRef(null);
  const assetRef = useRef(null);

  useEffect(() => { 
    setShow(isShow)
  }, [isShow]); 

   const handleSubmit = async (e) => {
    if (!assetName.trim() || !assetFile) {
    setAssetNameError(!assetName.trim());
    setAssetError(!assetFile);

    let object = [
        {
            key: assetName.trim(),
            ref: assetnameRef.current,
        },
        {
            key: assetFile,
            ref: assetRef.current,
        },
    ];

    for (let i = 0; i < object.length; i++) {
        if (!object[i].key) {
            object[i].ref.focus();
            break;
        }
    }
    return;
    }
    setAssetNameError(false);
    setAssetError(false);
    setIsLoading(true)
    setIsDisabled(true)
    // e.preventDefault();
    const formData = new FormData();
    formData.append('asset_name', assetName.trim());
    formData.append('asset', assetFile);

    createQuizAsset(formData).then((Response)=>{
      if(Response?.status){
      
        setIsDisabled(false)
        toast.success(Response?.message) 
        close()
      }else{
        setIsDisabled(false)
        toast.error(Response?.errorMessage)
        setIsLoading(false)
      } 
    }) 
  };
   const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (file && file.type.startsWith('audio/')) {
    setAssetFile(file);
    setAssetError(false)
    const reader = new FileReader();
    reader.onloadend = () => {
      setPreview(reader.result);
    };
    reader.readAsDataURL(file);
  } else {
    e.target.value = null
    setPreview(null);
    setAssetFile(null); 
  }
};

   return ( 
    <Modal show={show} onHide={()=>close(false)} backdrop="static" dialogClassName="modal-xl">
        <Modal.Header closeButton>
        <h5 className="modal-title">Add Asset</h5>
        </Modal.Header>
        <Modal.Body>
        <form className="row g-3">
              <div className="col-6 px-3">
                <label htmlFor="assetName" className="form-label required">Name</label>
                <input ref={assetnameRef} maxLength={50}
                onChange={(e) => {setAssetName(e.target.value)
                if (assetNameError && e.target.value.trim() !== '') {
                      setAssetNameError(false);
                }}} type="text" className="form-control" name="name" id="assetName" placeholder="Enter Asset Name" />
                <Form.Control.Feedback type="invalid" style={{ display: assetNameError ? 'block' : 'none' }}>
                  Asset name is required
              </Form.Control.Feedback> 
              </div>
             <div className="col-6 px-3">
                <label htmlFor="audioFile" className="form-label required">Audio Asset</label>
                <input
                  type="file"
                  name="audio"
                  className="form-control"
                  id="audioFile"
                  accept="audio/*"
                  onChange={handleFileChange}
                  ref={assetRef}
                />
                <Form.Control.Feedback type="invalid" style={{ display: assetError ? 'block' : 'none' }}>
                  Asset file is required
              </Form.Control.Feedback> 
                {preview && (
                  <div className="mt-3">
                    <p>Audio Preview:</p>
                    <div className="audio-preview">
                      <audio controls src={preview} controlsList="nodownload"/>
                    </div>
                  </div>
                )}
              </div>
                    {isLoading && <div className="progress-bar"></div>}
               <div className="modal-footer" >
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  onClick={()=>{close(false)}}
                >
                  Close
                </button>
                <button 
                disabled={isDisabled} 
                type="button" 
                className="btn btn-primary" 
                onClick={()=>handleSubmit()}>Save</button>
              </div> 
            </form>          
        </Modal.Body>
        {/* <Modal.Footer> */}
             
        {/* </Modal.Footer> */}
      </Modal>
       
  );
};

export default CreateAsset;

 